<template>
  <b-modal
    v-model="$show"
    centered
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    size="md"
    title="Delete Profile Picture"
  >
    <template>
      <h6 class="text-black-50">{{ message_detail }}</h6>
    </template>
    <template #modal-footer>
      <b-button variant="link" class="btn-link-dark" :disabled="isLoading" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="danger" :disabled="isLoading" @click="clickConfirm()">
        <span v-if="!isLoading">Delete</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },

    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    },

    noCloseOnEsc: {
      type: Boolean,
      default: true
    },

    isLoading: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },
    message_detail() {
      return 'Are you sure you want to delete profile picture';
    }
  },
  methods: {
    clickConfirm() {
      this.$emit('confirmed:delete');
    },
    cancel() {
      this.$emit('update:show', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>
